import { useQuery } from "@/api/swr/useQuery";
import { companyProfileSchema } from "@/schema/app/profile/CompanyProfile";

export function useGetCompanyProfile() {
  return useQuery(companyProfileSchema, "/app/company_info");
}
